"use strict";

var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");

var _createClass = require("@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("@babel/runtime/helpers/get");

var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbsorberSize = void 0;

var ValueWithRandom_1 = require("../../../../Options/Classes/ValueWithRandom");

var AbsorberSize = /*#__PURE__*/function (_ValueWithRandom_1$Va) {
  _inherits(AbsorberSize, _ValueWithRandom_1$Va);

  function AbsorberSize() {
    var _this;

    _classCallCheck(this, AbsorberSize);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbsorberSize).call(this));
    _this.density = 5;
    _this.random.minimumValue = 1;
    _this.value = 50;
    return _this;
  }

  _createClass(AbsorberSize, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      _get(_getPrototypeOf(AbsorberSize.prototype), "load", this).call(this, data);

      if (data.density !== undefined) {
        this.density = data.density;
      }

      if (data.limit !== undefined) {
        this.limit = data.limit;
      }

      if (data.limit !== undefined) {
        this.limit = data.limit;
      }
    }
  }]);

  return AbsorberSize;
}(ValueWithRandom_1.ValueWithRandom);

exports.AbsorberSize = AbsorberSize;